(function() { module.exports = this["ReactDOM"]; }());


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 6
// module chunks = 0